// extracted by mini-css-extract-plugin
module.exports = {"mediaTypeFrequenciesAndCirculation":"_3_Xr0IXr"};